import { render, staticRenderFns } from "./tab_maintain_order.vue?vue&type=template&id=4ff4c9f9&scoped=true"
import script from "./tab_maintain_order.vue?vue&type=script&lang=js"
export * from "./tab_maintain_order.vue?vue&type=script&lang=js"
import style0 from "./tab_maintain_order.vue?vue&type=style&index=0&id=4ff4c9f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff4c9f9",
  null
  
)

export default component.exports